const baseUrl = process.env.REACT_APP_BASE_URL
const locale = process.env.REACT_APP_DEFAULT_LANG
const sentryDSN = process.env.REACT_APP_SENTRY_DSN
const nodeENV = process.env.REACT_APP_NODE_ENV

export {baseUrl, locale, sentryDSN, nodeENV}
